import { FETCH_DATA, MAILBOXES_TO_ADD_COUNTER_CHANGE,SUBMIT_MAILBOX_UPDATE } from './constants'

const fetchData = () => ({ type: FETCH_DATA.INITIATE })
export const fetchDataSuccess = (data) => ({
  type: FETCH_DATA.SUCCESS,
  payload: { data },
})
export const fetchDataError = (error) => ({
  type: FETCH_DATA.ERROR,
  error,
})
const fetchDataCancel = () => ({ type: FETCH_DATA.CANCEL })

const submitMailboxUpdate = () => ({
  type: SUBMIT_MAILBOX_UPDATE.INITIATE,
})
export const submitMailboxUpdateSuccess = () => ({
  type: SUBMIT_MAILBOX_UPDATE.SUCCESS,
})
export const submitMailboxUpdateError = (error) => ({
  type: SUBMIT_MAILBOX_UPDATE.ERROR,
  error,
})
const submitMailboxUpdateCancel = () => ({ type: SUBMIT_MAILBOX_UPDATE.CANCEL })

const handleMailboxesCounterChange = (value) => ({
  type: MAILBOXES_TO_ADD_COUNTER_CHANGE,
  payload: { value },
})

export default {
  // to props
  fetchData,
  fetchDataCancel,
  submitMailboxUpdate,
  submitMailboxUpdateCancel,
  handleMailboxesCounterChange,
}
